import { render } from "./index.vue?vue&type=template&id=056fdf88&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=056fdf88&lang=scss"
import "./index.vue?vue&type=style&index=1&id=056fdf88&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056fdf88"]])

export default __exports__